import { Document } from "../../models/document";
import { ShipmentDocument } from "../../models/shipment.document";

export function mountShipmentDocumentFullData(
  shipmentDocument?: ShipmentDocument,
  document?: Document
): ShipmentDocument {
  return {
    ...document,
    ...shipmentDocument,
    name: shipmentDocument?.name || document?.name,
  } as ShipmentDocument;
}
